/**
 * MealTypeTabs — small pill segmented control for switching between
 * breakfast / lunch / dinner. Shared by PlannerHome's MEAL PLAN card and
 * the /planner/meals list so the switching UI stays identical.
 */
export const MEAL_TYPES = [
  { key: "breakfast", label: "Breakfast" },
  { key: "lunch", label: "Lunch" },
  { key: "dinner", label: "Dinner" },
];

export default function MealTypeTabs({ value, onChange, counts = {}, testidPrefix = "planner-meal-type" }) {
  return (
    <div
      role="tablist"
      aria-label="Meal type"
      className="inline-flex items-center gap-1 rounded-full bg-[#EDE5DA]/70 p-1 border border-[#A87F56]/25"
      data-testid={`${testidPrefix}-tabs`}
    >
      {MEAL_TYPES.map(({ key, label }) => {
        const active = value === key;
        const n = counts[key] || 0;
        return (
          <button
            key={key}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(key)}
            data-testid={`${testidPrefix}-tab-${key}`}
            className={`px-3 h-8 rounded-full text-xs tracking-wide transition ${
              active
                ? "bg-[#3E4A37] text-[#F7F3ED]"
                : "text-[#2A2823]/70 hover:text-[#2A2823]"
            }`}
          >
            {label}
            {n > 0 && (
              <span
                className={`ml-1.5 inline-flex items-center justify-center min-w-[16px] px-1 h-4 rounded-full text-[10px] ${
                  active ? "bg-[#F7F3ED]/25 text-[#F7F3ED]" : "bg-[#A87F56]/20 text-[#2A2823]/60"
                }`}
              >
                {n}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
